<template>
	<div class="app-container" 
	:lang="$i18n.locale"
	v-loading.fullscreen="uploadloading" :element-loading-text="$t('tipsInfo.uploading')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="listHeader">
			<i></i><span>{{$t('landOrder.landOrderList')}}</span>
		</div>
		<el-form style="margin:10px 0 0 0" :model="queryParams" ref="queryParams" :inline="true"
			label-width="auto">
			<el-form-item label prop="awbNo">
				<el-input v-model="queryParams.awbNo" clearable type="textarea"
					:placeholder="$t('commonInfo.orderNoColumn')" style="width: 200px;"></el-input>
			</el-form-item>
			<el-form-item>
				<el-select v-model="queryParams.warehouseType"
					:placeholder="$t('commonInfo.deliveryType')"
					style="width:200px" :clearable="true">
					<el-option v-for="item in warehouseTypeList" :key="item.id" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-date-picker v-model="queryParams.createTimeList" type="daterange" value-format="yyyy-MM-dd HH:mm:ss"
					range-separator="-" :start-placeholder="$t('commonInfo.beginTime')"
					:end-placeholder="$t('commonInfo.endTime')" style="width:300px"></el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button icon="el-icon-search" type="primary" @click="handleSearch">
					{{$t('commonInfo.searchBtn')}}</el-button>
				<el-button icon="el-icon-refresh" type="primary" @click="getlist">
					{{$t('commonInfo.refreshBtn')}}</el-button>
				<el-button icon="el-icon-refresh" @click="handleReset">{{$t('commonInfo.dialogBtnReset')}}
				</el-button>
			</el-form-item>
		</el-form>
		<el-table :data="tableData" ref="landOrderTable" border style="width: 100%;font-size: 16px;"
			v-loading="loading" >
			<el-table-column :label="$t('commonInfo.orderNoColumn')" prop="awbNo" min-width="160"
				align="center"></el-table-column>
			<el-table-column :label="$t('commonInfo.createTimeColumn')" prop="initTime" min-width="175"
				align="center"></el-table-column>
			<el-table-column :label="$t('commonInfo.deliveryType')" prop="warehouseType" min-width="120"
				align="center">
				<template slot-scope="{row}">
					<span>{{returnDeliveryType(row.warehouseType)}}</span>
				</template>
			</el-table-column>
			<el-table-column :label="$t('commonInfo.deliveryWarehouse')" prop="dest" min-width="160"
				align="center"></el-table-column>
			<el-table-column :label="$t('commonInfo.detailAddress')" prop="detailAddress" min-width="200" show-overflow-tooltip
				align="center"></el-table-column>
			<el-table-column :label="$t('landOrder.transportRoute')" prop="destCountry" min-width="160"
				align="center">
				<template slot-scope="{row}">
				  <div v-if="row.startCountry && row.startCountry != ''" class="countryLine">
				    <label>{{row.startCountry}}</label>
				    <i class="el-icon-right"></i>
				    <label>{{row.destCountry}}</label>
				  </div>
				</template>
			</el-table-column>
			<el-table-column :label="$t('chinaWhB2COrderPage.listTabTableColumnDestCity')" prop="destCity" min-width="140"
				align="center"></el-table-column>
			<el-table-column :label="$t('commonInfo.packageAmount')" prop="packageAmount" min-width="140"
				align="center"></el-table-column>
			<el-table-column :label="$t('commonInfo.inboundTime')" prop="entryTime" min-width="175"
				align="center"></el-table-column>
			<el-table-column :label="$t('commonInfo.statusColumn')" prop="memo" min-width="160"
				align="center"></el-table-column>
		</el-table>
		<div class="pageBottom">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="queryParams.page" :page-sizes="[10, 20, 30, 40]" :page-size="queryParams.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
		</div>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';
	export default {
		name:'LandOrderList',
		components: {
		},
		data() {
			return {
				uploadloading:false,
				
				queryParams: {
					page: 1,
					limit: 10,
					awbNo:'',
					awbNoList:[],
					warehouseType:'',
					createTimeList:[],
				},
				tableData: [],
				warehouseTypeList:[
					{
						id:1,
						label:'FBA',
						value:'1'
					},{
						id:2,
						label:'NOON',
						value:'2'
					},{
						id:3,
						label:'Carton',
						value:'3'
					},{
						id:4,
						label:'SKU',
						value:'4'
					},{
						id:5,
						label:'OWH',
						value:'5'
					}
				],
				loading: false,
				total: 0,
			}
		},
		//方法集合
		methods: {
			// 分页条数
			handleSizeChange(size) {
				this.queryParams.limit = size;
				this.queryParams.page = 1;
				this.getlist();
			},
			// 分页页数
			handleCurrentChange(page) {
				this.queryParams.page = page;
				this.getlist();
			},
			// 搜索订单列表
			handleSearch() {
				if (this.queryParams.awbNo != null && this.queryParams.awbNo != '') {
					this.queryParams.awbNoList = this.strToArr(this.queryParams.awbNo)
				} else {
					this.queryParams.awbNoList = [];
				}
				this.queryParams.page = 1;
				this.getlist();
			},
			// 重置
			handleReset() {
				this.queryParams = {
					page: 1,
					limit: 10,
					awbNo: '',
					awbNoList:[],
					warehouseType:'',
					createTimeList:[],
				}
				this.getlist();
			},
			// 获取列表
			async getlist() {
				this.loading = true;
				this.tableData = [];
				const res = await this.$http.post("/toborder/land/order/page", this.queryParams);
			
				if (res.code === 200) {
					let data = res.data.list;
					// 总共有多少条数据，分页
					this.total = res.data.totalCount;
					this.tableData = data;
					this.loading = false;
				} else {
					this.$message.error(res.msg);
					this.loading = false;
				}
			},
			// 返回派送类型
			returnDeliveryType(type){
				let text = '';
				let row = this.warehouseTypeList.filter(item => item.value == type);
				text = row[0].label;
				return text
			},
		},
		created() {
			this.getlist();
		},
	}
</script>

<style scoped>
	.listHeader {
		width: 100%;
		height: 50px;
		line-height: 50px;
		font-size: 22px;
	}
	
	.listHeader i {
		width: 4px;
		height: 40px;
		display: inline-block;
		background-color: #0077AA;
		float: left;
		margin: 5px 10px;
	}
	.listHeader span {
		display: inline-block;
		float: left;
	}
	.app-container {
		padding: 10px;
	}
	.countryLine {
	  margin-top: 5px;
	}
	.countryLine i{
	  margin: 0 5px;
	}
	.countryLine label:nth-child(1){
	  color: #1890ff;
	}
	.countryLine label:nth-child(3){
	  color: #11d85a;
	}
</style>
<style scoped lang="scss">
	// 阿拉伯语
	[lang="ar"] {
		.listHeader{
			i{
				float: right;
			}
			span{
				float: right;
			}
		}
		
		.el-form-item__content{
			.el-button--primary{
				margin-left: 10px;
			}
		}
		// 表格
		::v-deep .el-table__fixed-right{
			left: 0;
			right: auto;
			.el-table__fixed-body-wrapper{
				left: 0;
				right: auto;
			}
		}
		::v-deep .el-table__fixed-right .el-table__fixed-header-wrapper{
			left: 0;
			right: auto;
		}
		::v-deep .fixed-width .el-button{
			margin: 0 5px 0 0 !important;
			i{
				margin-left: 5px;
			}
		}
		::v-deep .el-dropdown{
			margin: 0 5px 0 0 !important;
			.batchInfoItem{
				width: 20px;
				height: 20px;
				left: -15px;
				right: auto;
				top:-5px;
			}
			span{
				margin-left: -5px;
				float: right;
			}
			i{
				float: right;
				margin: 6px 0 0 5px;
			}
		}
		::v-deep .is-dot {
			left: -2px;
			right: auto;
			top: 6px;
		}
		::v-deep .el-dialog__headerbtn{
			right: auto;
			left: 20px;
		}
		::v-deep .el-select .el-tag{
			margin: 0 5px;
		}
		::v-deep .el-select .el-tag__close.el-icon-close{
			right: 5px;
		}
	}
</style>